export enum DialogSize {
  SM = '480px',
  MD = '620px',
  LG = '720px',
  XL = '860px',
}
